export default async function minifyJS(input) {
  const {minify} = await import('terser')
  const result = await minify(input)
  return result.code
}
